export const tags = [
    'przenoska',
    'dla rodzin z dziećmi',
    'lasy',
    'łąki',
    'sklep na trasie',
];
